// extracted by mini-css-extract-plugin
module.exports = {"blackButton":"BlackButton_blackButton__TgdB0","gradient":"BlackButton_gradient___LEAR","buttonText":"BlackButton_buttonText__kkyif","link":"BlackButton_link__JF2pK"};